import { render, staticRenderFns } from "./ColorScore.vue?vue&type=template&id=6fa70e84&"
import script from "./ColorScore.vue?vue&type=script&lang=js&"
export * from "./ColorScore.vue?vue&type=script&lang=js&"
import style0 from "./ColorScore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports